import { ExperimentUtil } from 'client/utils/experiment/experiment-util';
import {
  getPagePublicationState,
  getPagePublicationStateFromUrlContext,
} from 'site-modules/shared/utils/inventory/srp-utils';
import { makeNiceName } from 'site-modules/shared/utils/nice-name';

export const SHOP_5160_SRP_TTFB_ADS_TARGETING_EXPERIMENT = 'shop-5160-srp-ttfb-ads-targeting';

export function getUrlVehicleForAdTargeting(urlContext, pageFilters) {
  const { vehicle: urlVehicle = {} } = urlContext || {};
  const { make: urlMake = {}, model: urlModel = {}, modelYear = {} } = urlVehicle || {};
  const {
    make: selectedMakes = [],
    model: selectedModels = [],
    year: selectedYears = [],
    bodyType: bodyTypes = [],
    inventoryType = [],
  } = pageFilters || {};
  const make = makeNiceName(urlMake?.slug || '');
  const model = makeNiceName(urlModel?.slug || '');
  const yearFilter = selectedYears?.[0] || '';
  // A single-year filter is formatted as "2021-2021"; \1 requires both years to match, and capture group 1 returns "2021".
  const exactYearFromFilter = /^(\d{4})-\1$/.exec(yearFilter)?.[1];

  if (
    selectedMakes.length !== 1 ||
    selectedModels.length !== 1 ||
    !make ||
    !model ||
    (yearFilter && !exactYearFromFilter)
  ) {
    return null;
  }

  const selectedModel = makeNiceName(selectedModels[0].split('|').pop());
  if (makeNiceName(selectedMakes[0]) !== make || selectedModel !== model) {
    return null;
  }

  const yearFromUrl = modelYear?.year;
  if (yearFromUrl && exactYearFromFilter && `${yearFromUrl}` !== exactYearFromFilter) {
    return null;
  }

  const year = yearFromUrl || exactYearFromFilter;
  const publicationState = inventoryType.length
    ? getPagePublicationState(inventoryType)
    : getPagePublicationStateFromUrlContext(urlContext);

  return {
    make: { niceName: make, adTargetId: urlMake?.adTargetId },
    model: { niceName: model, adTargetId: urlModel?.adTargetId },
    modelYear: { year },
    ...(bodyTypes.length ? { type: { niceName: bodyTypes.join().toLowerCase() } } : {}),
    publicationState,
  };
}

export function isShop5160SrpAdsTargetingEligible(urlContext, pageFilters) {
  const { rooftopId } = pageFilters || {};
  const urlVehicle = getUrlVehicleForAdTargeting(urlContext, pageFilters);
  return !rooftopId && !!urlVehicle;
}

export function isShop5160SrpTtfbAdsTargetingChal(state, urlContext, pageFilters) {
  const { rooftopId } = pageFilters || {};
  if (rooftopId) {
    return false;
  }

  const recipe = ExperimentUtil.getForcedOrAssignedRecipeName({
    state,
    campaignName: SHOP_5160_SRP_TTFB_ADS_TARGETING_EXPERIMENT,
    defaultVal: 'ctrl',
  });
  return recipe === 'chal' && isShop5160SrpAdsTargetingEligible(urlContext, pageFilters);
}
